
import { Button } from "@/components/ui/button";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { CalendarDays } from "lucide-react";
import { format } from "date-fns";
import { cn } from "@/lib/utils";
import { DateRange } from "@/hooks/useSearchFilters";

interface DateFilterProps {
  dateRange: DateRange;
  setDateRange: (range: DateRange) => void;
  handleDatePreset: (preset: 'today' | 'this-week' | 'next-week') => void;
}

export const DateFilter = ({ dateRange, setDateRange, handleDatePreset }: DateFilterProps) => {
  return (
    <div>
      <h3 className="text-sm font-medium mb-2">Meal Date</h3>
      <div className="flex flex-wrap gap-2 mb-2">
        <Button
          variant="outline"
          size="sm"
          onClick={() => handleDatePreset('today')}
          className="text-black"
        >
          Today
        </Button>
        <Button
          variant="outline"
          size="sm"
          onClick={() => handleDatePreset('this-week')}
          className="text-black"
        >
          This week
        </Button>
        <Button
          variant="outline"
          size="sm"
          onClick={() => handleDatePreset('next-week')}
          className="text-black"
        >
          Next week
        </Button>
      </div>
      <div className={cn("grid gap-2", dateRange.from && "grid-cols-1 md:grid-cols-2")}>
        <Popover>
          <PopoverTrigger asChild>
            <Button
              variant="outline"
              className={cn(
                "w-full justify-start text-left font-normal text-black",
                !dateRange.from && "text-muted-foreground"
              )}
            >
              <CalendarDays className="mr-2 h-4 w-4" />
              {dateRange.from ? format(dateRange.from, "PPP") : "Pick a date"}
            </Button>
          </PopoverTrigger>
          <PopoverContent className="w-auto p-0 bg-white" align="start">
            <Calendar
              initialFocus
              mode="range"
              defaultMonth={dateRange.from}
              selected={{ from: dateRange.from, to: dateRange.to }}
              onSelect={(range) => setDateRange({
                from: range?.from,
                to: range?.to
              })}
              numberOfMonths={1}
              className="bg-white rounded-md border"
            />
          </PopoverContent>
        </Popover>
        {dateRange.from && (
          <Popover>
            <PopoverTrigger asChild>
              <Button
                variant="outline"
                className="w-full justify-start text-left font-normal text-black"
              >
                <CalendarDays className="mr-2 h-4 w-4" />
                {dateRange.to ? format(dateRange.to, "PPP") : "Pick a date"}
              </Button>
            </PopoverTrigger>
            <PopoverContent className="w-auto p-0 bg-white" align="start">
              <Calendar
                initialFocus
                mode="range"
                defaultMonth={dateRange.from}
                selected={{ from: dateRange.from, to: dateRange.to }}
                onSelect={(range) => setDateRange({
                  from: range?.from,
                  to: range?.to
                })}
                numberOfMonths={1}
                className="bg-white rounded-md border"
              />
            </PopoverContent>
          </Popover>
        )}
      </div>
    </div>
  );
};
